module.exports = __webpack_public_path__ + "static/certyfikatTUV-9fc53055e4bde8195bd00fc66aa18522.webp";